import axios from 'axios'

//changed : baseURL: 'http://m1.test.mar.tv/tickets'

const axiosInstance = axios.create({
    // baseURL: 'http://localhost:80',
    baseURL: 'http://m1.test.mar.tv/tickets',
    timeout: 1000
});

axiosInstance.interceptors.request.use( config =>  {
    const token = localStorage.token;
    if(token){
        config.headers.Authorization =  'Bearer ' + token;
    }
    return config;
});

axiosInstance.interceptors.response.use(response => {
    return response;
  }, error => {
    if(error.response.status === 401){
        localStorage.removeItem('token');
    }
    return Promise.reject(error);
  });

export default axiosInstance;


